<!--员工帐号管理-->
<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form class="flex-form " layout="inline" :form="form" :colon="false">
          <div class="grid grid-cols-2 2xl:grid-cols-3">
            <a-form-item label="员工姓名">
              <a-input v-decorator="['nickname']" placeholder="请输入员工姓名" autocomplete="off"></a-input>
            </a-form-item>

            <a-form-item label="员工状态">
              <a-select
                class="form-control"
                :options="typesMap.statusTypeList"
                v-decorator="['status']"
                allowClear
                placeholder="请选择"
              ></a-select>
            </a-form-item>
          </div>
        </a-form>

        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery$qv">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="doQuery(1)">立即搜索</a-button>
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">员工帐号列表</div>
      <div class="queryView-actions">
        <a-button class="app-btn" @click="addEmployee">
          <app-icon type="icon-tianjia"></app-icon>
          新建员工
        </a-button>
      </div>
      <div class="queryView-main">
        <!-- :scroll="{ x: 1400 }" -->
        <a-table
          class="mt-5"
          rowKey="userId"
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        ></a-table>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { waitFor } from '@/utils'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '5%',
        align: 'center',
        customRender: (text, row, index) => {
          return <span> {this.pageSize * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '员工姓名',
        width: '15%',
        align: 'center',
        dataIndex: 'nickname',
      },
      {
        title: '登录手机',
        width: '15%',
        align: 'center',
        dataIndex: 'phoneNumber',
      },
      {
        title: '角色权限',
        width: '15%',
        align: 'center',
        dataIndex: 'roleName',
      },
      {
        title: '状态',
        width: '15%',
        align: 'center',
        dataIndex: 'status',
        customRender: (text, row) => {
          return <div>{this.translateType$t(text, 'statusTypeList')}</div>
        },
      },

      {
        title: '操作',
        width: '20%',
        align: 'center',
        customRender: (text, row) => {
          return (
            <div class="flex gap-5 justify-center text-primary-500">
              <span
                type="icon-bianji"
                class="cursor-pointer"
                onClick={() => {
                  this.editRow(row)
                }}
              >
                编辑
              </span>

              <span
                type={row.status == 10 ? 'icon-qiyong' : 'icon-jinyong'}
                class="cursor-pointer"
                onClick={() => {
                  this.changeDisable(row)
                }}
              >
                {row.status == 10 ? '启用' : '禁用'}
              </span>
              <span
                type="icon-shanchu"
                class="cursor-pointer"
                onClick={() => {
                  this.deleteRow(row)
                }}
                title=""
              >
                删除
              </span>
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        data: {},
      },
      modal1: {
        visible: false,
      },
      dataSource: [],
      rowUserId: '',
    }
  },
  components: {
    Page,
    PictureCardUpload,
    VueQrcode,
  },
  computed: {
    typesMap() {
      return {
        statusTypeList: [
          { value: 0, label: '正常' },
          { value: 10, label: '已禁用' },
        ],
      }
    },
  },
  methods: {
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {
      this.tableLoading = true
      try {
        const { nickname, status } = this.form.getFieldsValue()
        const res = await this.$axios.get('/user/admin/employee', {
          params: {
            page: _pageNumber,
            limit: _pageSize,
            nickname: nickname,
            status: status,
          },
        })
        this.countTotal = Number(res.count)
        this.pageSize = _pageSize
        this.pageNumber = _pageNumber
        this.dataSource = res.data
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    editRow(row) {
      this.$router.push({
        path: '/m/scopeMain/empAccountManage/addEmployee',
        query: {
          userId: row.userId,
        },
      })
    },
    async deleteRow(row) {
      await this.$modal({
        title: '确认删除？',
        content: <div class="h-28 flex items-center justify-center text-red-400">你确认要删除该员工？</div>,
      })
      await this.$axios.delete(`/user/admin/employee/${row.userId}`)
      // /user/admin/employee/{userId}
      this.$message.success('操作成功')
      this.doQuery()
    },
    async changeDisable(row) {
      const title = row.status == 10 ? '启用员工账号' : '禁用员工账号'
      const content = (
        <div class="h-28 flex items-center justify-center text-red-400">
          {row.status == 10 ? '你确定要启用员工帐号？' : '你确认要禁用该员工帐号？'}
        </div>
      )
      await this.$modal({
        title,
        content,
      })
      await this.$axios.put(`/user/admin/employee/status?userId=${row.userId}&status=${row.status == 10 ? 0 : 10}`)
      this.$message.success('操作成功')
      this.doQuery()
    },
    addEmployee() {
      this.$router.push({
        path: '/m/scopeMain/empAccountManage/addEmployee',
      })
    },
    async handleOk() {
      await new Promise((resolve, reject) => {
        this.$confirm({
          title: '提示',
          content: '正在等待绑定，是否关闭?',
          onOk: () => {
            resolve()
          },
          onCancel: () => {
            reject(new Error('E_CANCEL'))
          },
        })
      })
      this.modal.data.cancel()
      this.modal.visible = false
    },
    async handleOk1() {
      // TODO 解除绑定
      this.modal.visible = false
    },
    async handle1() {
      this.modal1.visible = false
    },
  },
  mounted() {
    this.doQuery()
  },
}
</script>

<style lang="less" scoped>
.qrcode-container {
  width: 148px;
  height: 148px;
  background: #ddd;
}
.botton-s {
  border: 2px solid #dfdfdf;
  padding: 5px 10px;
  cursor: pointer;
}
</style>
